"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputLabelProps = exports.EMAIL_INPUT = void 0;
const EMAIL_INPUT = exports.EMAIL_INPUT = 'email-input';
const inputLabelProps = exports.inputLabelProps = {
  shrink: true
};
